import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
      <div className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center px-4 py-8 sm:py-10">
        <Link
          to="/"
          className="mb-8 flex items-center gap-2 text-gray-900 dark:text-white"
          aria-label="Paysafi home"
        >
          <Logo size={36} />
          <span className="text-lg font-semibold tracking-tight">Paysafi</span>
        </Link>
        <div className="card w-full p-6 sm:p-8">
          <div className="mb-6">
            <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">{title}</h1>
            {subtitle ? (
              <p className="mt-1.5 text-sm text-gray-500 dark:text-gray-400">{subtitle}</p>
            ) : null}
          </div>
          {children}
        </div>
        {footer ? (
          <p className="mt-6 text-sm text-gray-500 dark:text-gray-400">{footer}</p>
        ) : null}
      </div>
    </div>
  );
}
